import { DASHBOARD_ROUTES } from '@admin-platform/shared/constants';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL ?? '';

export function Navigation() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav className="nav">
      <Link to="/" className="nav__brand" onClick={close}>
        <svg className="nav__logo-icon" viewBox="0 0 32 32" fill="none" width="32" height="32" aria-hidden>
          <rect width="32" height="32" rx="8" fill="#00d9a6" />
          <g transform="translate(4 6.5)">
            <path
              d="M1.021 10.5625C4.31511 10.5625 5.13864 2.78709 6.7857 1.15015C8.43276 -0.0775511 8.84453 7.6979 10.0798 13.8364C10.9033 17.5195 12.1386 17.9287 13.3739 15.4733C15.021 12.1995 16.2563 5.24249 17.9033 4.42402C19.1386 4.01479 20.3739 8.51636 22.021 8.51636"
              stroke="#082535"
              strokeWidth="2.04195"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
        <span className="nav__logo-text">Revvly</span>
      </Link>

      <button
        type="button"
        className="nav__toggle"
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? <X size={24} /> : <Menu size={24} />}
      </button>

      <div className={`nav__right${open ? ' nav__right--open' : ''}`}>
        <Link to="/pricing" className="nav__login" onClick={close}>
          Pricing
        </Link>
        <Link to="/docs" className="nav__login" onClick={close}>
          Docs
        </Link>
        <Link to="/blog" className="nav__login" onClick={close}>
          Blog
        </Link>
        <a href={`${dashboardUrl}${DASHBOARD_ROUTES.login}`} className="nav__login" onClick={close}>
          Login
        </a>
        <Link to="/early-access" className="nav__cta" onClick={close}>
          Get Early Access
        </Link>
      </div>
    </nav>
  );
}
